export default "__VITE_ASSET__DSwrGVm5__"